import React from 'react'
import { Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import gfm from 'remark-gfm'

import Heading from './heading'
import styles from '../component-styles/card.module.scss'

interface Props {
  heading: string
  color: string
  copy: string
  features: string[]
  to: string
}

export default function Card({
  heading,
  color,
  copy,
  features,
  to,
}: Props): React.ReactElement {
  return (
    <Link to={to} className={styles.card}>
      <div
        className={styles.hover}
        style={{
          backgroundColor: color,
        }}
      >
        <Heading type={5} align="left">
          {heading}
        </Heading>
      </div>
      <Heading
        type={2}
        className={styles.heading}
        style={{
          backgroundColor: color,
        }}
      >
        {heading}
      </Heading>
      <div
        className={styles.copyContainer}
        style={{
          borderColor: color,
        }}
      >
        <ReactMarkdown plugins={[gfm]}>{copy}</ReactMarkdown>
        <Heading type={4} align="left" className={styles.keyFeatureHeading}>
          Key features:
        </Heading>
        <ul className={styles.ul}>
          {features.map(
            (feature): React.ReactElement => (
              <li key={feature}>{feature}</li>
            ),
          )}
        </ul>
      </div>
    </Link>
  )
}
